import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import type { SelfDto } from "@/api/types";
import { useSelfAccountQueries } from "@/queries/self-account/queryOptions";

export interface SessionUserInitialOptions {
  keepPreviousData?: boolean;
}

export function useSessionUserInitial(
  projectId: string | undefined,
  options?: SessionUserInitialOptions,
): UseQueryResult<SelfDto> {
  const selfAccountQueries = useSelfAccountQueries();

  return useQuery(selfAccountQueries.sessionUserInitial(projectId, options?.keepPreviousData));
}
